import React from 'react';
import './HintSection.css';

function HintSection() {
  // 定义提示数组
  const hints = [
    { id: 1, text: "Foodie trip in Beijing" },
    { id: 2, text: "Things to do in Shanghai with kids" },
    { id: 3, text: "Travel to Xian with my wife" },
    { id: 4, text: "Relaxing beach holiday in Hainan" }
  ];

  return (
    <div className="hint-section">
      <div className="hint-row">
        <div className="hint-item" onClick={() => {
            window.location.href = `/search/${hints[0].text}`;
        }}>
            <div className="hint-item-logo">
                <span>&#x1F4F8;</span>
            </div>
            <div className="hint-item-content">
                <span>{hints[0].text}</span>
            </div>
        </div>
        <div className="hint-item" onClick={() => {
            window.location.href = `/search/${hints[1].text}`;
        }}>
            <div className="hint-item-logo">
                <span>&#x1F9F3;</span>
            </div>
            <div className="hint-item-content">
                <span>{hints[1].text}</span>
            </div>
        </div>
      </div>
      <div className="hint-row">
        <div className="hint-item" onClick={() => {
            window.location.href = `/search/${hints[2].text}`;
        }}>
            <div className="hint-item-logo">
                <span>&#x1F3E8;</span>
            </div>
            <div className="hint-item-content">
                <span>{hints[2].text}</span>
            </div>
        </div>
        <div className="hint-item" onClick={() => {
            window.location.href = `/search/${hints[3].text}`;
        }}>
            <div className="hint-item-logo">
                <span>&#x1F37A;</span>
            </div>
            <div className="hint-item-content">
                <span>{hints[3].text}</span>
            </div>
        </div>
      </div>
    </div>
  );
}

export default HintSection;